export enum CornerstoneImages {
  CT = "CT",
  MR = "MR",
}
